import { type SxProps, type Theme } from '@mui/material';
import { Z_INDEX } from '@/styles/zindex';

export const drawerSX: SxProps<Theme> = {
	zIndex: Z_INDEX.MINI_CART_DRAWER,
};

export const containerSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'stretch',
	height: 'auto',
	maxHeight: '90vh',
	position: 'fixed',
	bottom: 0,
	left: 0,
	right: 0,
	zIndex: 1000000,
	borderTopLeftRadius: '10px',
	borderTopRightRadius: '10px',
	backgroundColor: '#FFFFFF',
	overflow: 'hidden',
};

export const closeIconSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-xl)',
	cursor: 'pointer',
	position: 'absolute',
	top: '14px',
	right: '14px',
	zIndex: 2,
};

export const scrollAreaSX: SxProps<Theme> = {
	width: '100%',
	flex: 1,
	minHeight: 0,
	overflowY: 'auto',
	paddingTop: '30px',
	paddingX: '30px',
	paddingBottom: '20px',
};

export const titleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-lg)',
	color: '#2C2C2C',
	fontWeight: 800,
	display: 'flex',
	alignItems: 'center',
	marginBottom: '20px',
	textTransform: 'uppercase',
};

export const titleImageSX: SxProps<Theme> = {
	height: '27px',
	width: '27px',
	marginRight: '11px',
};

export const itemsStackSX: SxProps<Theme> = {
	maxHeight: 160,
	overflowY: 'auto',
};

export const dividerSX: SxProps<Theme> = {
	marginTop: '20px',
	marginBottom: '11px',
};

export const footerSX: SxProps<Theme> = {
	width: '100%',
	paddingX: '30px',
	paddingTop: '16px',
	paddingBottom: '20px',
	backgroundColor: '#FFFFFF',
	borderTop: '1px solid #E5E5E5',
	flexShrink: 0,
};

export const cartButtonSX: SxProps<Theme> = {
	backgroundColor: '#F1F1F1',
	color: '#2C2C2C',
	borderRadius: 50,
	height: '46px',
	paddingLeft: '20px',
	paddingRight: '20px',
	fontWeight: 600,
	fontSize: 'var(--font-size-body)',
	minWidth: '48%',
};

export const checkoutButtonSX: SxProps<Theme> = {
	backgroundColor: '#FF4900',
	color: '#FFFFFF',
	borderRadius: 50,
	height: '46px',
	paddingLeft: '20px',
	paddingRight: '20px',
	fontWeight: 600,
	minWidth: '48.5%',
	fontSize: 'var(--font-size-body)',
	':disabled': {
		backgroundColor: '#B5B5B5',
		color: '#FFFFFF',
	},
};
